var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "media-buttons", class: _vm.containerClass },
    [
      _c(
        "div",
        { staticClass: "buttons" },
        _vm._l(_vm.buttons, function(button, index) {
          return _c(
            "button",
            {
              key: index,
              staticClass: "media-button",
              class:
                _vm.decoreActive && button.name == _vm.active ? " active" : "",
              attrs: { disabled: button.disabled },
              on: {
                click: function($event) {
                  $event.stopPropagation()
                  return _vm.selected(button)
                }
              }
            },
            [
              _vm.icons && button.icon
                ? [
                    _c("masked-image", {
                      staticClass: "button-icon",
                      attrs: { src: button.icon }
                    })
                  ]
                : _vm._e(),
              _vm._v(" "),
              _c("span", { domProps: { innerHTML: _vm._s(button.label) } })
            ],
            2
          )
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }